import { gql } from "@apollo/client";

const SET_COMPANION_SESSION_SELECTED_ESTIMATE_ITEM_CHOICE = gql`
  mutation SetCompanionSessionSelectedEstimateItemChoice(
    $companionSessionEstimateItemUuid: String!
    $inventoryItemUuid: String!
  ) {
    setCompanionSessionSelectedEstimateItemChoice(
      companionSessionEstimateItemUuid: $companionSessionEstimateItemUuid
      inventoryItemUuid: $inventoryItemUuid
    ) {
      ok
    }
  }
`;

export default SET_COMPANION_SESSION_SELECTED_ESTIMATE_ITEM_CHOICE;
